var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Moveable",
    _vm._b(
      {
        ref: "handler",
        staticClass: "draggable-field",
        class: { "is-selected": _vm.selected },
        style: _vm.style,
        on: {
          click: function($event) {
            return _vm.$emit("select")
          },
          dragStart: _vm.onGestureStart,
          drag: _vm.handleDrag,
          dragEnd: _vm.handleDragEnd,
          resizeStart: _vm.onGestureStart,
          resize: _vm.handleResize,
          resizeEnd: _vm.handleResizeEnd
        }
      },
      "Moveable",
      _vm.moveable,
      false
    ),
    [
      _c("FieldBox", {
        attrs: {
          type: _vm.field.type,
          label: _vm.field.label,
          required: _vm.field.required,
          placeholder: _vm.field.placeholder,
          "box-height": _vm.live.height,
          "font-size-px": _vm.previewFontSizePx,
          alignment: _vm.previewAlignment,
          selected: _vm.selected,
          closable: _vm.closable
        },
        on: {
          close: function($event) {
            return _vm.$emit("delete")
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }